import { registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import localeEsAr from '@angular/common/locales/es-AR'
import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { environment } from '../environments/environment'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BasicAuthInterceptor } from './helpers/basic-auth.interceptor'
import { ErrorInterceptor } from './helpers/error.interceptor'
import { LegalesComponent } from './legales/legales.component'
import { SafeHtmlPipe } from './shared/pipes/safeHtml.pipe'
import { SharedModule } from './shared/shared.module'
import { TopBarComponent } from './top-bar/top-bar.component'
registerLocaleData(localeEsAr, 'es-Ar')

@NgModule({ declarations: [AppComponent, TopBarComponent, LegalesComponent, SafeHtmlPipe],
    bootstrap: [AppComponent], imports: [BrowserModule, AppRoutingModule, SharedModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: 'environment', useValue: environment },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
